import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { modelColumns } from '../../data/snakkerStory';
export function SlideModel({}: SlideProps) {
  return <InteriorSlide surface data-id="element-463" data-mp="mdawc1eqllzv">
      <SlideTitle eyebrow="The Snakker model" data-id="element-464" data-mp="qd1uiq6lf4ef">
        Attention <span className="font-light text-[var(--brand-light)]" data-id="element-465" data-mp="qemjm0a51v4w">→</span> Understanding{' '}
        <span className="font-light text-[var(--brand-light)]" data-id="element-466" data-mp="3pti007x5jj8n">→</span> <span className="text-[var(--brand)]" data-id="element-467" data-mp="3urrtme38abs5">Action</span>
      </SlideTitle>

      <div className="mt-[clamp(1.5rem,3vw,2.75rem)] grid min-h-0 flex-1 grid-cols-1 md:grid-cols-3" data-id="element-468" data-mp="2mfvtpihawh3">
        {modelColumns.map((col, i) => <motion.section key={col.title} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15 + i * 0.12,
        duration: 0.5
      }} className={`flex min-h-0 flex-col border-t-2 pt-[clamp(1rem,2vw,1.75rem)] md:pr-[clamp(1.25rem,2.5vw,2.5rem)] ${i === 2 ? 'border-[var(--brand)]' : 'border-[var(--fg)]'} ${i > 0 ? 'md:pl-[clamp(1.25rem,2.5vw,2.5rem)] md:border-l md:border-l-[var(--fg)]/10' : ''}`} data-id="element-469" data-mp="7nlojnc52jqm" data-mpi={i}>
            <span className="font-mono text-[clamp(0.62rem,0.8vw,0.74rem)] tracking-[0.2em] text-[var(--muted)]" data-id="element-470" data-mp="26a549jo4bdje">0{i + 1}</span>
            <h3 className={`mt-2 text-[clamp(1.8rem,3.4vw,3.2rem)] font-extrabold leading-none tracking-[-0.05em] ${i === 2 ? 'text-[var(--brand)]' : 'text-[var(--fg)]'}`} data-id="element-471" data-mp="1x85kwkpmrxda">
              {col.title}
            </h3>
            <p className="mt-[clamp(0.9rem,1.8vw,1.5rem)] text-[clamp(1.05rem,1.6vw,1.5rem)] font-bold leading-snug tracking-[-0.02em] text-[var(--fg)]" data-id="element-472" data-mp="1nfhse25oofkd">
              {col.lead}
            </p>
            {col.verbs && <ul className="mt-[clamp(0.75rem,1.4vw,1.2rem)] flex flex-wrap gap-1.5" data-id="element-473" data-mp="19hje0wrd4j4v">
                {col.verbs.map(v => <li key={v} className="rounded-full border border-[var(--fg)]/15 bg-white px-3 py-1 text-[clamp(0.7rem,0.9vw,0.86rem)] font-semibold text-[var(--fg)]" data-id="element-474" data-mp="yw69zh2o1lel">
                    {v}
                  </li>)}
              </ul>}
            {col.body && <p className="mt-[clamp(0.75rem,1.4vw,1.2rem)] max-w-sm text-[clamp(0.85rem,1.15vw,1.08rem)] leading-snug text-[var(--muted)]" data-id="element-475" data-mp="1il6v0u6f9b0o">
                {col.body}
              </p>}
          </motion.section>)}
      </div>

      <ClosingLine delay={0.6} data-id="element-476" data-mp="18ulzxgpyiomi">
        The Snak is not another channel. It is the{' '}
        <span className="text-[var(--brand)]" data-id="element-477" data-mp="1dsx9rrg94z4q">interactive layer between attention and action.</span>
      </ClosingLine>
    </InteriorSlide>;
}